import React, { useEffect, useRef } from "react";

import WithUs from "../Landing/WithUs/WithUs";
import Footer from "../../Components/Footer/Footer";
import DigitalMarketingTypes from "./DigitalMarketingTypes/DigitalMarketingTypes";
import DigitalMarketingLandingPortfolioPart from "./DigitalMarketingLandingPortfolioPart/DigitalMarketingLandingPortfolioPart";
import AboutDigitalMarketing from "./AboutDigitalMarketing/AboutDigitalMarketing";
import DigitalMarketingHero from "./DigitalMarketingHero/DigitalMarketingHero";
import SeoHelmet from "../../Components/SeoHelmet";

const DigitalMarketingLanding = () => {
  const scrollRef = useRef(null)
  useEffect(()=>{
    scrollRef.current.scrollIntoView()
  }
,[])
  return (
    <div className="overflow-hidden">
      <div ref={scrollRef}></div>
      <SeoHelmet
        title="SunMed | Digital Marketing"
        description="  We focus on creating campaigns that don’t just reach people but
        resonate with them. By combining innovative ideas with analytics and
        insights, we ensure every effort is purposeful, measurable, and
        aligned with your business goals."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
      <DigitalMarketingHero />
      <AboutDigitalMarketing />
      <DigitalMarketingLandingPortfolioPart />
      <DigitalMarketingTypes />
      <WithUs />
      <Footer />
    </div>
  );
};

export default DigitalMarketingLanding;
